import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen bg-[#1B4332] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/87a9474c0df53cf7ee001da33f24ac3a.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1B4332]/60 via-[#1B4332]/20 to-[#1B4332]/80" />
      </div>

      {/* Grid texture overlay */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: "linear-gradient(rgba(255,255,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.3) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-32 pb-24">
        <div className="max-w-2xl">
          {/* Label */}
          <div className="inline-flex items-center gap-2 mb-8 px-4 py-1.5 border border-white/20 rounded-full">
            <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full animate-pulse"></span>
            <span className="text-white/60 text-xs tracking-widest uppercase">2026 精選系列</span>
          </div>

          {/* Title */}
          <h1 className="text-[clamp(48px,8vw,96px)] font-extralight leading-none tracking-tight text-white mb-2">
            MINIMAL
          </h1>
          <h2 className="text-[clamp(48px,8vw,96px)] font-extralight leading-none tracking-tight text-white/20 mb-2 pl-8 md:pl-16">
            DESIGN
          </h2>
          <h2 className="text-[clamp(48px,8vw,96px)] font-extralight leading-none tracking-tight text-white mb-8 pl-4 md:pl-8">
            EXCELLENCE
          </h2>

          {/* Divider */}
          <div className="w-24 h-px bg-white/30 mb-6" />

          {/* Subtitle */}
          <p className="text-white/50 text-lg leading-relaxed mb-10 max-w-md">
            精選 8 件頂尖 3C 家電，iPhone、MacBook、Dyson 等頂尖品牌，<br className="hidden md:block" />
            為你打造極致購物體驗。
          </p>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/shop"
              className="inline-flex items-center justify-center px-10 py-4 bg-white text-[#1B4332] text-sm font-semibold tracking-widest hover:bg-white/90 transition-all duration-200 rounded-sm cursor-pointer whitespace-nowrap"
            >
              探索商品
            </Link>
            <Link
              to="/features"
              className="inline-flex items-center justify-center px-10 py-4 border border-white/30 text-white text-sm font-medium tracking-widest hover:bg-white/5 transition-all duration-200 rounded-sm cursor-pointer whitespace-nowrap"
            >
              查看特色
            </Link>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-24 flex flex-wrap gap-12">
          {[
            { value: "8+", label: "精選商品" },
            { value: "NT$0", label: "免運費" },
            { value: "7天", label: "無憂退換" },
            { value: "4.8", label: "平均評分" },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col gap-1">
              <span className="text-3xl font-extralight text-white tracking-wide">{stat.value}</span>
              <span className="text-xs text-white/40 tracking-widest uppercase">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <i className="ri-arrow-down-line text-white/30 text-2xl"></i>
        <span className="text-white/20 text-[10px] tracking-widest">SCROLL</span>
      </div>
    </section>
  );
}
